export default __webpack_public_path__ + "static/media/vehicle_search_img.52c2094e.png";